module.exports = __webpack_public_path__ + "img/logo.001ae13.svg";